import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {Route} from "react-router";
import {NavLink} from "react-router-dom";

import {openAppMenu, closeAppMenu} from "state/app/actions";
import {isMenuOpen, getUserIdentityAppReferrer} from "state/app/selectors";

import Accent from "components/app/bar/Accent";
import HamburgerMenu from "components/app/bar/HamburgerMenu";
import Context from "components/app/bar/Context";

import "./AppBar.css";

// Presentational component
class AppBar extends React.Component {

  render() {
    // Swap the menubutton onclick to close if the menu is open, and vice versa
    const menuButtonOnClick = this.props.isMenuOpen ? this.props.closeAppMenu : this.props.openAppMenu;
    const appReferrer = this.props.appReferrer;
    const productTitle = appReferrer === process.env.REACT_APP_XPRESSIONS_APP_REFERRER || appReferrer === process.env.REACT_APP_PARENTAPPS_APP_REFERRER
      ? process.env.REACT_APP_SCHOOLMONEY_APP_NAME : process.env.REACT_APP_EDUSPOT_APP_NAME;
    // Update the app title if its only sm app
    if(appReferrer === process.env.REACT_APP_XPRESSIONS_APP_REFERRER || appReferrer === process.env.REACT_APP_PARENTAPPS_APP_REFERRER) {
        document.title = "SchoolMoney";
    }
    return (
      <div className="app-bar">
        <div className="app-bar__brand">
          <Route path="/:product?" component={Accent} />
          <NavLink to="/" className="app-bar__title" activeClassName="app-bar__title--selected">{productTitle}</NavLink>
        </div>
        <HamburgerMenu isMenuOpen={this.props.isMenuOpen} onClick={menuButtonOnClick} />
        { /* Context needs a location object for transitions */ }
        <Route component={Context} />
      </div>
    );
  }
}

// container component
export default connect(
  (state) => ({
    isMenuOpen: isMenuOpen(state),
    appReferrer: getUserIdentityAppReferrer(state)
  }),
  (dispatch) => bindActionCreators({
    openAppMenu,
    closeAppMenu
  }, dispatch),
  null,
  // The appbar is impure because it depends on routing state
  // This is required to make the appbar re-render on location change (outside of the menu click)
  { pure: false }
)(AppBar);



// WEBPACK FOOTER //
// ./src/components/app/bar/AppBar.js